// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-B7o_H5"};